import { render, staticRenderFns } from "./ValorMensal.vue?vue&type=template&id=4227d358&lang=pug&"
import script from "./ValorMensal.vue?vue&type=script&lang=js&"
export * from "./ValorMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports